import { Box, Button, Card, Container, Grid, Typography } from "@mui/material";
import { find } from "lodash";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import Dialog from "../../components/shared/Dialog";
import Dropdown from "../../components/shared/DropDown";
import List from "../../components/shared/List";

import { useDispatch } from "react-redux";
import Iconify from "../../components/iconify/iconify";

import {
  getHelpList,
  getPaginationInfo,
} from "../../data/selectors/Help/help.selector";
import useHelp from "../../data/talons/Help/useHelp";
import { color } from "../../utils/constant";
import HelpForm from "./helpForm";
import { useForm } from "react-hook-form";
import { useHelpForm } from "../../data/talons/Help/useHelpForm";
import { resetState } from "../../data/reducers/Help/helpForm.reducer";

/**
 * Render Category screen with list of data
 * data will taken from the selector
 *
 */
export default function Help() {
  const [showDialog, setShowDialog] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [editId, setEditId] = useState(null);
  const HelpList = useSelector(getHelpList);
  const paginationInfo = useSelector(getPaginationInfo);
  const { setValue, control } = useForm();
  const [Open, setOpen] = useState(false);
  const { getHelpById, helpDelete, handleDeleteId } = useHelpForm({});

  const dispatch = useDispatch();
  const {
    gridHeaders,
    loading,
    status,
    StatusList,
    handleStatusChange,
    fetchHelpList,
  } = useHelp();

  useEffect(() => {
    fetchHelpList({
      current_page: 1,
      row_count: rowsPerPage,
    });
  }, [rowsPerPage]);

  const onSubmit = useCallback(
    async (e) => {
      e?.preventDefault();
      await fetchHelpList({
        current_page: 1,
        row_count: rowsPerPage,
      });
    },
    [fetchHelpList]
  );

  // const editObj = useMemo(() => {
  //   return find(HelpList, ["id", editId]);
  // }, [editId, HelpList]);

  return (
    <Container
      sx={{
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        mt: 1,
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3} md={2}>
          <Dropdown
            size={"small"}
            title={"Status"}
            data={StatusList}
            handleDropdownChange={handleStatusChange}
            dropdownValue={status}
            allReqired={true}
            allStatusVal="0"
          />
        </Grid>
        <Grid
          container
          direction="row"
          justify="flex-right"
          item
          xs={6}
          sm={3}
          md={2}
        >
          <Button
            variant="contained"
            onClick={onSubmit}
            sx={{
              maxHeight: 40,
              backgroundColor: color.button,
              borderRadius: 3,
              "&:hover": {
                backgroundColor: color.button,
              },
            }}
          >
            Get Data
          </Button>
        </Grid>
        <Grid
          item
          xs={6}
          sm={3}
          md={2}
          sx={{ marginLeft: "auto", textAlign: "end" }}
        >
          <Button
            sx={{
              height: 40,
              borderRadius: 3,
              backgroundColor: color.button,
              "&:hover": {
                backgroundColor: color.button,
              },
            }}
            onClick={() => setShowDialog(true)}
            variant="contained"
            startIcon={<Iconify icon="mingcute:add-line" />}
          >
            {"New"}
          </Button>
          <Dialog
            handleClose={() => {
              setShowDialog(false);
              setEditId(null);
              fetchHelpList({ current_page: 1, row_count: rowsPerPage });
            }}
            open={showDialog}
            fullWidth={true}
          >
            <HelpForm
              postSubmit={async () => {
                setShowDialog(false);
                setEditId(null);
                await fetchHelpList({
                  current_page: 1,
                  row_count: rowsPerPage,
                });
                dispatch(resetState());
              }}
              editId={editId}
              // editItem={editObj}
            />
          </Dialog>
          <Dialog
            handleClose={() => {
              setOpen(false);
            }}
            open={Open}
            // fullWidth={true}
          >
            <Typography sx={{ fontWeight: "bold" }}>
              Confirm to Delete this Data ?.
            </Typography>
            <Box sx={{ display: "flex", gap: 1, mt: 2, justifyContent: "end" }}>
              <Button
                onClick={async () => {
                  const res = await helpDelete();
                  if (res == true) {
                    setOpen(false);
                    await getHelpById(editId);
                    fetchHelpList({ current_page: 1, row_count: rowsPerPage });
                  }
                }}
                sx={{ background: color.button }}
                variant="contained"
              >
                Yes
              </Button>
              <Button
                onClick={() => setOpen(false)}
                sx={{ background: color.button }}
                variant="contained"
              >
                No
              </Button>
            </Box>
          </Dialog>
        </Grid>
      </Grid>
      <Card
        sx={{
          flexGrow: { md: 1 },
          display: { md: "flex" },
          flexDirection: { md: "column" },
          my: "12px",
          borderRadius: "12px",
          boxShadow:
            "0 0 2px 0 rgba(145, 158, 171, 0.2),0 12px 24px -4px rgba(145, 158, 171, 0.12)",
        }}
      >
        <List
          loading={loading}
          data={HelpList}
          paginationData={paginationInfo}
          columnsData={gridHeaders}
          getRowId={(row) => row.id}
          autoHeight={true}
          pageCount={Number(paginationInfo.total_page)}
          totalRecords={paginationInfo.total_count}
          onPageChange={async (page, rowsPerPage) => {
            setRowsPerPage(rowsPerPage);
            await fetchHelpList({
              current_page: page,
              row_count: rowsPerPage,
            });
          }}
          enableDelete
          onDeleteIconpress={async (row) => {
            handleDeleteId(row);
            setOpen(true);
          }}
          enableEdit
          onEditIconPress={async (id) => {
            await getHelpById(id);
            setEditId(id);
            setShowDialog(true);
          }}
        />
      </Card>
    </Container>
  );
}
